// Quick setup templates for common company configurations
// ESSENTIALS (included in all templates): PSA, AEM, Fincon, IT Glue

const ESSENTIALS = ['PSA', 'AEM', 'Fincon', 'IT Glue'];

export const WIZARD_TEMPLATES = [
  {
    id: 'mail-only',
    name: 'Mail Only',
    description: 'Essentials | Email Migration | Domain DNS',
    icon: 'building',
    color: 'blue',
    defaults: {
      hasServers: false,
      systems: [...ESSENTIALS],
      tasks: ['Email Migration', 'Domain DNS'],
      company: {
        paymentTerms: '30 Days',
      },
      branchTemplate: {
        hasFirewall: false,
        numberOfUsers: 0,
        numberOfDevices: 0,
        numberOfNetworkDevices: 0,
        numberOfServers: 0,
      },
    },
  },
  {
    id: 'mail-backups',
    name: 'Mail + Backups',
    description: 'Essentials | Email Migration | Domain DNS | Include Backups',
    icon: 'cloud',
    color: 'purple',
    defaults: {
      hasServers: false,
      systems: [...ESSENTIALS],
      tasks: ['Email Migration', 'Domain DNS', 'Include Backups'],
      company: {
        paymentTerms: '30 Days',
      },
      branchTemplate: {
        hasFirewall: false,
        numberOfUsers: 0,
        numberOfDevices: 0,
        numberOfNetworkDevices: 0,
        numberOfServers: 0,
      },
    },
  },
  {
    id: 'full-stack',
    name: 'Full Stack',
    description: 'Essentials | Email Migration | Domain DNS | Include Backups | Acronis Email Security',
    icon: 'rocket',
    color: 'cyan',
    defaults: {
      hasServers: true,
      systems: [...ESSENTIALS],
      tasks: ['Email Migration', 'Domain DNS', 'Include Backups', 'Acronis Advanced Email Security'],
      company: {
        paymentTerms: 'Month End',
      },
      branchTemplate: {
        hasFirewall: false,
        numberOfUsers: 0,
        numberOfDevices: 0,
        numberOfNetworkDevices: 0,
        numberOfServers: 0,
      },
    },
  },
  {
    id: 'scratch',
    name: 'Start from Scratch',
    description: 'Begin with a blank slate and configure everything manually',
    icon: 'edit',
    color: 'gray',
    defaults: null,
  },
];

// Get template by ID
export function getTemplateById(id) {
  return WIZARD_TEMPLATES.find(t => t.id === id) || null;
}

// Get default branch from template
export function getDefaultBranch(template) {
  if (!template || !template.defaults?.branchTemplate) {
    return {
      name: '',
      contactPerson: '',
      contactNumber: '',
      emailAddress: '',
      address: '',
      city: '',
      province: '',
      postalCode: '',
      country: '',
      hasFirewall: false,
      numberOfUsers: 0,
      numberOfDevices: 0,
      numberOfNetworkDevices: 0,
      numberOfServers: 0,
    };
  }
  
  return {
    name: '',
    contactPerson: '',
    contactNumber: '',
    emailAddress: '',
    address: '',
    city: '',
    province: '',
    postalCode: '',
    country: '',
    ...template.defaults.branchTemplate,
  };
}
